<template>
  <q-page class="flex column home page-layout">
    <div class="grid-container-2-columns">
      <!-- Filter -->
      <section class="grid-container-2-columns__item--full-row">
        <q-card flat class="filter-card">
          <q-card-section class="filter-card__section">
            <TheSiteSelector v-on:updateFilter="handleFilterUpdate($event)" />
          </q-card-section>
        </q-card>
      </section>
      <!-- Summary -->
      <section class="grid-container-2-columns__item">
        <q-card flat class="content-card">
          <q-card-section class="content-card__section">
            <TheLiveAcquisitionSummary
              dataset="LiveAcquisitions_Summary"
              :filter="filterOption"
            />
          </q-card-section>
        </q-card>
      </section>
      <!-- Chart -->
      <section class="grid-container-2-columns__item">
        <q-card flat class="d3-card">
          <q-card-section class="d3-card__section">
            <TheLiveAcquisitionChart
              :filter="filterOption"
              dataset="LiveAcquisitions_Chart"
            />
          </q-card-section>
        </q-card>
      </section>
      <section class="grid-container-2-columns__item">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <TheLiveAcquisitionFilterTable
              :filter="filterOption"
              dataset="LiveAcquisitions_Channels"
              :timer="180000"
            />
          </q-card-section>
        </q-card>
      </section>

      <section class="grid-container-2-columns__item">
        <q-card flat class="table-card">
          <q-card-section class="table-card__section">
            <TheLiveAcquisitionDataTable
              :filter="filterOption"
              dataset="LiveAcquisitions_Search"
              :timer="180000"
            />
          </q-card-section>
        </q-card>
      </section>
    </div>
  </q-page>
</template>

<script>
import TheSiteSelector from "@/components/filters/TheSiteSelector.vue";
import TheLiveAcquisitionSummary from "@/components/other/TheLiveAcquisitionSummary.vue";
import TheLiveAcquisitionChart from "@/components/charts/TheLiveAcquisitionChart.vue";
import TheLiveAcquisitionFilterTable from "@/components/tables/TheLiveAcquisitionFilterTable.vue";
import TheLiveAcquisitionDataTable from "@/components/tables/TheLiveAcquisitionDataTable.vue";
export default {
  name: "LiveAccquistion",
  data() {
    return {
      filterOption: {
        siteId: 0,
        networkId: 0,
        operatorId: 0,
      },
    };
  },
  components: {
    TheSiteSelector,
    TheLiveAcquisitionSummary,
    TheLiveAcquisitionChart,
    TheLiveAcquisitionFilterTable,
    TheLiveAcquisitionDataTable,
  },
  methods: {
    handleFilterUpdate: function(filterOption) {
      this.filterOption = filterOption;
    },
  },
};
</script>
